// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"371":"bc596283","720":"cb72bea7"}[chunkId] + ".chunk.css";
};